import { Trade } from '@public/Trade'

// export { getStaticProps }

export default Trade
